import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  pages: [],
  singlePage: null,
};

export const createPage = createAsyncThunk(
  "createPage/pages",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("meta-tags", data);
      enqueueSnackbar("Page is added successfully");
      navigate(PATH_DASHBOARD.meta.pages.list);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchPages = createAsyncThunk(
  "fetchPages/pages",
  async ({ limit, page }, thunkApi) => {
    try {
      const response = await axiosInstance.get(
        `meta-tags?limit=${limit}&page=${page + 1}`
      );
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error });
    }
  }
);

export const fetchSinglePage = createAsyncThunk(
  "fetchSinglePage/pages",
  async ({ slug }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`meta-tags/${slug}`);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error });
    }
  }
);

export const updatePage = createAsyncThunk(
  "updatePage/pages",
  async ({ slug, data, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`meta-tags/${slug}`, data);
      return {
        data: response.data.data,
        enqueueSnackbar,
        slug,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deletePage = createAsyncThunk(
  "deletePage/pages",
  async ({ id, enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      await axiosInstance.delete(`meta-tags/${id}`);
      thunkApi.dispatch(fetchPages({ limit, page }));
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const pageSlice = createSlice({
  name: "page",
  initialState,
  extraReducers: (builder) => {
    // TODO: create page
    builder.addCase(createPage.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createPage.fulfilled, (state, action) => {
      state.isLoading = false;
      state.pages.data = [action.payload, ...state.pages.data];
      state.pages.meta.total = state.pages.meta.total + 1;
    });

    builder.addCase(createPage.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch page
    builder.addCase(fetchPages.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchPages.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.pages = action.payload;
    });

    builder.addCase(fetchPages.rejected, (state, action) => {
      state.fetchLoading = false;
    });

    // ==========================

    // TODO: fetch single page
    builder.addCase(fetchSinglePage.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSinglePage.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.singlePage = action.payload;
    });

    builder.addCase(fetchSinglePage.rejected, (state, action) => {
      state.fetchLoading = false;
      if (action.payload?.enqueueSnackbar) {
        action.payload.enqueueSnackbar(action.payload.error.message, {
          variant: "error",
        });
      }
    });

    // ==========================

    // TODO: update page
    builder.addCase(updatePage.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updatePage.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Page is updated successfully");
      // state.pages.data = state.pages.data.map((page) =>
      //   page.slug === action.payload.slug ? action.payload.data : page
      // );
      // action.payload.setOpenEdit(false);
    });

    builder.addCase(updatePage.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete page
    builder.addCase(deletePage.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deletePage.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Page is deleted successfully");
    });

    builder.addCase(deletePage.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default pageSlice.reducer;
